import en from '../locales/en.json';
import de from '../locales/de.json';
import fr from '../locales/fr.json';
import it from '../locales/it.json';
import es from '../locales/es.json';
import zh from '../locales/zh.json';
import ko from '../locales/ko.json';
import ar from '../locales/ar.json';

const translations = {
  en,
  de,
  fr,
  it,
  es,
  zh,
  ko,
  ar
};

export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'it', 'es', 'zh', 'ko', 'ar'];
// All eight Yacht-copy locales are now translated, so every selector entry
// is enabled.
export const ENABLED_LANGUAGES = ['en', 'de', 'fr', 'it', 'es', 'zh', 'ko', 'ar'];
export const DEFAULT_LANGUAGE = 'en';

export const isLanguageEnabled = (lang) => ENABLED_LANGUAGES.includes(lang);

// Language detection priority:
// 1. URL parameter (?lang=de)
// 2. localStorage
// 3. Cookie
// 4. Browser language
// 5. Default (en)
export const detectLanguage = () => {
  // 1. Check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang && ENABLED_LANGUAGES.includes(urlLang.toLowerCase())) {
    return urlLang.toLowerCase();
  }

  // 2. Check localStorage
  const storedLang = localStorage.getItem('myt_language');
  if (storedLang && ENABLED_LANGUAGES.includes(storedLang)) {
    return storedLang;
  }

  // 3. Check cookie
  const cookieLang = getCookie('myt_language');
  if (cookieLang && ENABLED_LANGUAGES.includes(cookieLang)) {
    return cookieLang;
  }

  // 4. Check browser language
  const browserLang = navigator.language || navigator.userLanguage;
  const primaryLang = browserLang.split('-')[0].toLowerCase();
  if (ENABLED_LANGUAGES.includes(primaryLang)) {
    return primaryLang;
  }

  // 5. Default
  return DEFAULT_LANGUAGE;
};

// Helper to get cookie value
const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Save language preference
export const saveLanguagePreference = (lang) => {
  // Save to localStorage
  localStorage.setItem('myt_language', lang);

  // Save to cookie (365 days expiry)
  const date = new Date();
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
  document.cookie = `myt_language=${lang};expires=${date.toUTCString()};path=/;SameSite=Lax`;
};

// Get translation by key path (e.g., "form.firstName")
export const getTranslation = (translations, keyPath, replacements = {}) => {
  const keys = keyPath.split('.');
  let value = translations;

  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return keyPath; // Return key if translation not found
    }
  }

  // Replace placeholders like {name}
  if (typeof value === 'string' && Object.keys(replacements).length > 0) {
    return value.replace(/\{(\w+)\}/g, (match, key) => {
      return replacements[key] !== undefined ? replacements[key] : match;
    });
  }

  return value;
};

export const getTranslations = (lang) => {
  return translations[lang] || translations[DEFAULT_LANGUAGE];
};

export default translations;
